import React from 'react';
import CouponsListPage from './pages/CouponsListPage';
import CreateCouponPage from './pages/CreateCouponPage';
import EditCouponPage from './pages/EditCouponPage';
import ViewCouponPage from './pages/ViewCouponPage';

export const COUPONS_PATHS = {
  list: '/coupons',
  create: '/coupons/create',
  edit: (id) => `/coupons/${id}/edit`,
  view: (id) => `/coupons/${id}`,
};

export const couponsRoutes = [
  { path: COUPONS_PATHS.list, element: <CouponsListPage /> },
  { path: COUPONS_PATHS.create, element: <CreateCouponPage /> },
  { path: COUPONS_PATHS.edit(':id'), element: <EditCouponPage /> },
  { path: COUPONS_PATHS.view(':id'), element: <ViewCouponPage /> },
];

export const couponsNavItem = {
  id: 'coupons',
  label: 'Coupons',
  iconName: 'localOffer',
  path: COUPONS_PATHS.list,
  match: (pathname) => pathname.startsWith('/coupons'),
  order: 2,
};
